import { type FC } from 'react';

import { ElectionSVG } from '../../../components/reusable/svgs';
import { useOrganizationContext } from '../../../context/organization';

interface Props {
	collapsed?: boolean;
}

export const SidebarElectionChip: FC<Props> = ({ collapsed = false }) => {
	const organization = useOrganizationContext();
	const hasElection = !!organization.selectedElection.electionId;
	const electionName = organization.selectedElection.electionName;
	const canChange = !organization.isCandidate;

	const onOpen = () => {
		if (!canChange) return;
		organization.onSelectElection();
	};

	if (collapsed) {
		return (
			<div
				className={`sidebar-election-chip sidebar-election-chip--collapsed ${
					hasElection ? 'sidebar-election-chip--active' : 'sidebar-election-chip--empty'
				}`}
				title={hasElection ? `Election: ${electionName}` : 'No election selected'}
				aria-label={hasElection ? `Active election ${electionName}` : 'No election selected'}
			>
				<span className='sidebar-election-chip__indicator' />
			</div>
		);
	}

	return (
		<button
			type='button'
			className={`sidebar-election-chip ${
				hasElection ? 'sidebar-election-chip--active' : 'sidebar-election-chip--empty'
			} ${canChange ? '' : 'sidebar-election-chip--locked'}`.trim()}
			onClick={onOpen}
			disabled={!canChange && !hasElection}
			aria-label={hasElection ? `Active election ${electionName}. Click to change.` : 'Choose election'}
		>
			{hasElection ? (
				<>
					<span className='sidebar-election-chip__indicator' />
					<span className='sidebar-election-chip__content'>
						<span className='sidebar-election-chip__label'>Active Election</span>
						<span
							className='sidebar-election-chip__name'
							title={electionName}
						>
							{electionName}
						</span>
					</span>
					<span className='sidebar-election-chip__live'>LIVE</span>
					{canChange && (
						<svg
							className='sidebar-election-chip__chevron'
							width='12'
							height='12'
							viewBox='0 0 24 24'
							fill='none'
							aria-hidden='true'
						>
							<path
								d='M9 18l6-6-6-6'
								stroke='currentColor'
								strokeWidth='2'
								strokeLinecap='round'
								strokeLinejoin='round'
							/>
						</svg>
					)}
				</>
			) : (
				<>
					<span className='sidebar-election-chip__icon'>
						<ElectionSVG />
					</span>
					<span className='sidebar-election-chip__empty-text'>{canChange ? 'Choose election' : 'No election yet'}</span>
					{canChange && <span className='sidebar-election-chip__cta'>Select</span>}
				</>
			)}
		</button>
	);
};
